import { Icon, type IconProps } from "./icon";

/** Admin: a shield with a check, the platform's own administration (not a section's settings). */
export function AdminIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M10 2.75 15.75 4.9v4.6c0 3.45-2.35 6.2-5.75 7.75C6.6 15.7 4.25 12.95 4.25 9.5V4.9L10 2.75Z" />
      <path d="m7.4 9.9 1.9 1.9 3.4-3.6" />
    </Icon>
  );
}
